let uuid = 0;
export default function useId(): string {
  return String(uuid++);
}
